module.exports = "<div class=\"alarm-group-popup\">\r\n    <create-edit-popup options=\"options\"></create-edit-popup>\r\n</div>"